import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ContactUsPage } from './contactUs/contactUsPage';
import { GameGuidePage } from './gameGuidePage/gameGuidePage';
import { InfoRedirectPage } from './infoRedirectPage/infoRedirectPage';
import { PrivacyPolicyPage } from './privacyPolicyPage/privacyPolicyPage';
import { RecoverLoginPage } from './recoverLoginPage/recoverLoginPage';
import { RootPage } from './rootPage/rootPage';
import { TermsPage } from './termsPage/termsPage';
import { VerifyPage } from './verifyPage/verifyPage';
function getBasename() {
    let publicPathFromEnv = process.env.PUBLIC_PATH;
    if (!publicPathFromEnv) {
        return '/';
    }
    if (!publicPathFromEnv.startsWith('/')) {
        publicPathFromEnv = `/${publicPathFromEnv}`;
    }
    while (publicPathFromEnv.endsWith('/')) {
        publicPathFromEnv = publicPathFromEnv.substring(0, publicPathFromEnv.length - 1);
    }
    return publicPathFromEnv;
}
const router = createBrowserRouter([
    {
        path: '/',
        element: _jsx(RootPage, {})
    },
    {
        path: 'contact',
        element: _jsx(ContactUsPage, {})
    },
    {
        path: 'guide',
        element: _jsx(GameGuidePage, {})
    },
    {
        path: 'guide/:guidePageType',
        element: _jsx(GameGuidePage, {})
    },
    {
        path: 'info',
        element: _jsx(InfoRedirectPage, {})
    },
    {
        path: 'info/:guidePageType',
        element: _jsx(InfoRedirectPage, {})
    },
    {
        path: 'privacy-policy',
        element: _jsx(PrivacyPolicyPage, {})
    },
    {
        path: 'terms',
        element: _jsx(TermsPage, {})
    },
    {
        path: 'verify',
        element: _jsx(VerifyPage, {})
    },
    {
        path: 'verify/:uuid',
        element: _jsx(VerifyPage, {})
    },
    {
        path: 'recover-login',
        element: _jsx(RecoverLoginPage, {})
    },
    {
        path: 'recover-login/:uuid',
        element: _jsx(RecoverLoginPage, {})
    }
], { basename: getBasename() });
export const PageRouter = () => {
    return _jsx(RouterProvider, { router: router });
};
